import React, { FC } from 'react';
import { ButtonColors, ButtonFormats } from '@mts-ds/components/dist/types/components/button/enums';

import ContentFilter from '../../../../components_/Content/ContentFilter';
import FormRow from '../../../../components_/Form/FormRow';
import FormCol from '../../../../components_/Form/FormCol';
import Input from '../../../../components_/Fields/Input';
import Button from '../../../../components_/Fields/Button';
import Dropdown from '../../../../components_/Fields/Dropdown';
import { IData } from '../../../../models/equipmentDevices';
import checkFilter from '../../../../utils/checkFilter';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from 'antd';
import { IProps as IListProps } from './';

const useStyles = makeStyles(({ spacing }) => ({
  addButton: {
    // float: 'right',
    marginBottom: '0.25rem'
  },
  exportButton: {
    // float: 'left',
    marginBottom: '0.25rem',
    marginRight: '1rem'
  },
  resetButton: {
    marginBottom: '0.25rem'
  }
}));
interface IProps {
  data: IData;
  list: IListProps['list']['data'];
  filter: any;
  onChange: any;
  onClickCreate: () => void;
  onReset: () => void;
  onClickExport: () => void;
  isLoadingExportList: boolean;
}

const Filter: FC<IProps> = ({
  data,
  list,
  filter,
  onChange,
  onClickCreate,
  onReset,
  isLoadingExportList,
  onClickExport
}) => {
  const { fullTextSearch, ProtectionClassId } = filter;
  const { isShowReset, isDownload } = checkFilter(filter, [], list);
  const classes = useStyles();
  const { types } = data;

  return (
    <ContentFilter>
      <FormRow alignItems="flex-end">
        <FormCol xs={3}>
          <Input
            name="fullTextSearch"
            type="search"
            label=""
            placeholder="ID, тип устройства, владелец"
            clear
            value={fullTextSearch}
            onMtsChange={onChange}
          />
        </FormCol>
        <FormCol xs={3}>
          <Dropdown
            name="ProtectionClassId"
            label="Тип устройства"
            placeholder="Выберите тип устройства"
            value={ProtectionClassId}
            options={types}
            onMtsChange={onChange}
          />
        </FormCol>
        <FormCol xs={2}>
          {isShowReset && (
            <Button
              className={classes.resetButton}
              color={'ghost' as ButtonColors}
              onClick={onReset}
            >
              Сбросить фильтры
            </Button>
          )}
        </FormCol>
        <FormCol style={{ display: 'flex', justifyContent: 'flex-end' }} xs={4}>
          <Tooltip title="Экспорт в CSV">
            <Button
              format={'icon' as ButtonFormats}
              className={classes.exportButton}
              icon="list"
              color={'secondary' as ButtonColors}
              disabled={isDownload}
              loading={isLoadingExportList}
              onClick={onClickExport}
            />
          </Tooltip>
          <Button
            className={classes.addButton}
            icon="plus"
            color={'secondary' as ButtonColors}
            onClick={onClickCreate}
          >
            Добавить устройство
          </Button>
        </FormCol>
      </FormRow>
    </ContentFilter>
  );
};

export default Filter;
